import { JSX, useEffect, useRef } from 'react';
import { Button } from '@mantine/core';
import { IconMessageDots } from '@tabler/icons-react';
import * as Sentry from '@sentry/react';

function FeedbackButton(): JSX.Element {
  const icon = <IconMessageDots size={16} />;
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const feedback = Sentry.getFeedback();
    if (feedback && buttonRef.current) {
      feedback.attachTo(buttonRef.current, {
        formTitle: 'Provide Feedback',
        submitButtonLabel: 'Submit',
        messagePlaceholder: 'What did you expect? What happened instead?',
      });
    }
  }, []);

  return (
    <Button
      ref={buttonRef}
      style={{
        bottom: '17px',
        left: '-5px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
        zIndex: 9999,
      }}
      radius="xl"
      variant="outline"
      bg="white"
      color="blue.7"
      leftSection={icon}
    >
      Provide Feedback
    </Button>
  );
}

export default FeedbackButton;
